import { EnvironmentInjector, Injectable, inject, runInInjectionContext } from '@angular/core';

import { RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { BogVersion } from '@frontend/sports/types/configuration/client-configuration';

import { BestOddsGuaranteedService } from './best-odds-guaranteed.service';
import { ClassicBestOddsGuaranteedService } from './classic-best-odds-guaranteed.service';
import { TokenBasedBestOddsGuaranteedService } from './token-based-best-odds-guaranteed.service';

@Injectable({ providedIn: 'root' })
export class BestOddsGuaranteedFactoryService {
    private racingConfig = inject(RacingConfig);
    private envInjector = inject(EnvironmentInjector);

    create(): BestOddsGuaranteedService {
        const Impl = this.racingConfig.bogVersion === BogVersion.TokenBased ? TokenBasedBestOddsGuaranteedService : ClassicBestOddsGuaranteedService;
        return runInInjectionContext(this.envInjector, () => new Impl());
    }
}
